(function () {
  $(function () {
    $(document)
      .on('ccMembersUpdateSuccess', handleCCMembersUpdateSuccess)
      .on('ajax:success', '.form-edit-cc-members', handleCCMembersFormSubmitSuccess)
      .on('ajax:success', '.form-new-comment', handleUpdateCCMembersAfterCreateCommentSuccess)
      .on('ajax:success', '.form-edit-comment', handleUpdateCCMembersAfterUpdateCommentSuccess)
      .on('ajax:success', '#donot-bother-me-button, #notify-me-button', function (e, data, status) {
        if (data.success) {
          var $button = $(e.currentTarget)
          var $settings = $button.closest('.cc-members-settings')
          var originalTip = $button.text()
          var originalHref = $button.attr('href')
          var tip = $button.is('#notify-me-button') ?
                      '本页通知已开' :
                      '本页通知已关，有人 @ 你时会重新开启';

          updateCCMembers(data['cc_members'], false);
          $button
            .attr('href', 'javascript:;')
            .text(tip);
          setTimeout(function() {
            $button.fadeOut(400, function () {
              $settings.toggleClass('will-notify-me');
              $(this)
                .removeAttr('style')
                .attr('href', originalHref)
                .text(originalTip);
            });
          }, 3000);
        }
      })
      .on('click', '.form-edit-cc-members .member-list input[name="cc_members[guids][]"]', function (e) {
        var $notify = $(this).closest('.form-edit-cc-members');
        tower.refreshCCGroup($notify);
      })
      .on('click', '.btn-remove-dialog', function (e) {
        simple.dialog.removeAll()
      })
  })

  var handleCCMembersUpdateSuccess = function (event, data) {
    updateCCMembers(data['cc_members'])
  }

  var handleCCMembersFormSubmitSuccess = function (event, data, status) {
    simple.dialog.removeAll()
    $(document).trigger('ccMembersUpdateSuccess', data)
  }

  var handleUpdateCCMembersAfterCreateCommentSuccess = function (event, data, status) {
    updateCCMembers(data['cc_members'])
  }

  var handleUpdateCCMembersAfterUpdateCommentSuccess = function (event, data, status) {
    updateCCMembers(data['cc_members'])
  }

  var updateCCMembers = function (ccMembersData, updateSettings) {
    var $currentPage = $('.page:last')
    var $ccMembers = $currentPage.find('.cc-members')
    var ccMemberGuids = ccMembersData.map(function (item) { return item.guid })
    if (typeof updateSettings == 'undefined') updateSettings = true

    $ccMembers.attr('data-cc-members', ccMemberGuids.join(','))
    if (ccMembersData.length == 0) {
      $ccMembers.addClass('empty')
      $ccMembers.find('.avatars').empty()
    } else {
      $ccMembers.removeClass('empty')
      renderCCMembersList(ccMembersData)
    }
    if (updateSettings) {
      var $ccMembersSettings = $ccMembers.find('.cc-members-settings')
      var willNotifyMe = ccMemberGuids.indexOf(tower.me.guid) > -1

      $ccMembersSettings[willNotifyMe ? 'addClass' : 'removeClass']('will-notify-me')
    }
  }

  var renderCCMembersList = function (ccMembersData) {
    if (!ccMembersData) return

    var $currentPage = $('.page:last')
    var $ccMembers = $currentPage.find('.cc-members')
    var $ccMemberAvatars = $ccMembers.find('.avatars')
    var ccMembersCount = ccMembersData.length
    var visibleCcMembersCount = $ccMemberAvatars.data('visible-count')
    var ccMembersUrl = $ccMemberAvatars.data('url')
    var ccMembersListHTML = ''

    ccMembersData.slice(0, visibleCcMembersCount).forEach(function (item) {
      ccMembersListHTML += '<img alt="' + item.nickname + '" class="avatar" data-position="top" data-tooltip="' + item.nickname + '" src="' + item.gavatar + '">'
    })

    if (ccMembersCount > visibleCcMembersCount) {
      var unVisibleCcMembersCount = ccMembersCount - visibleCcMembersCount
      var text = unVisibleCcMembersCount > 99 ? '99+' : ('+' + unVisibleCcMembersCount)
      ccMembersListHTML += '<a href="' + ccMembersUrl + '" class="avatars-more" data-loading="true" data-remote="true">' + text + '</a>'
    }

    $ccMemberAvatars.html(ccMembersListHTML)
  }

  $.extend(tower, {
    editCCMembers: function (options) {
      var $currentPage = $('.page:last')
      var $form = $(options.form)
      var $members = $form.find('.member-list')
      var $dialogContent = $('<div>')
                            .append('<h4 class="simple-dialog-title">编辑通知成员</h4>')
                            .append($form)
                            .children()

      if ($currentPage.is('[data-visitor-locked]')) {
        $members.find('input.visitor:checkbox').closest('li').remove()
      }
      simple.dialog({
        content: $dialogContent,
        buttons: null,
        width: 600,
        cls: 'dialog-edit-cc-members'
      })
      tower.adjustSubGroupsTag($members)
      tower.refreshCCGroup($form)
    }
  })
}())
